import { ALLOWED_HOSTS } from './allowlist';
import { MalvertisingDetector } from './detector';

const TRACKJS_TOKEN = '05ce83f61b344c7bbc64052fc3fadde3';
const TRACKJS_AGENT_SRC = 'https://cdn.trackjs.com/agent/v3/latest/t.js';
const AUTO_REDIRECT_WINDOW_MS = 8000;

/**
 * Starts the malvertising forced-redirect detector for logged-in advanced-AV users only —
 * the segment where the observed campaign (4819) serves into the .18ad69c2 slots. The
 * detector is passive: it never blocks anything, it only reports a hit to TrackJS.
 */
export function initMalvertisingDetector(): void {
    const av = window.getAVCookie?.();
    const isLoggedInAv = !!av && av.type === 'advanced' && !av.required && !av.isGuest;
    if (!isLoggedInAv) return;

    const application = window.innerWidth < 768 ? 'sb-mobile' : 'sb-desktop';

    new MalvertisingDetector({
        allowedHosts: ALLOWED_HOSTS,
        autoRedirectWindowMs: AUTO_REDIRECT_WINDOW_MS,
        trackJsToken: TRACKJS_TOKEN,
        application,
        trackJsAgentSrc: TRACKJS_AGENT_SRC,
    }).start();
}
